"use client";

import * as React from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../context/AuthContext";
import { useCurrency } from "../../context/CurrencyContext";
import Button from "../Button";

interface Props {
  prepaidNumberSteps?: React.ReactNode;
}

const VisitorSignup: React.FC<Props> = ({ prepaidNumberSteps }) => {
  const { t } = useTranslation("consultations");
  const { signup, login } = useAuth();
  const { currency } = useCurrency();

  return (
    <>
      <div className="flex flex-col p-6 bg-slate-100 rounded-sm gap-4">
        {/* <div className="text-lg font-semibold text-center">{t(`consultation.visitor.pricing.${currency.toLowerCase()}`)}</div> */}
        <div className="text-sm text-center">{t("consultation.visitor.explaination")}</div>
        <div className="text-sm text-center font-semibold">{t("consultation.visitor.registration")}</div>
        {prepaidNumberSteps}
      </div>

      <div className="mt-8 flex flex-col">
        <Button size="large" onClick={() => signup()}>{t("consultation.visitor.signup")}</Button>
        <div className="text-center mt-3">
          <button type="button" onClick={() => login()}>
            {t("consultation.visitor.login")}
          </button>
        </div>
      </div>
    </>

  );
};

export default VisitorSignup;
